import { BaseApiService } from '../base/BaseApiService';
import { ApiResponse } from '../../types/api';

export interface LoginAuditDto {
  id: string;
  userId: string | null;
  username: string | null;
  ipAddress: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
  userAgent: string | null;
  success: boolean;
  failureReason: string | null;
  createdAt: string;
}

export interface LoginAuditPagedResponse {
  items: LoginAuditDto[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

class LoginAuditService extends BaseApiService {
  async getLogins(
    page: number = 1,
    pageSize: number = 20,
    filters?: { username?: string; dateFrom?: string; dateTo?: string; success?: boolean }
  ): Promise<LoginAuditPagedResponse> {
    const params: Record<string, string | number | boolean> = { page, pageSize };
    if (filters?.username) params.username = filters.username;
    if (filters?.dateFrom) params.dateFrom = filters.dateFrom;
    if (filters?.dateTo) params.dateTo = filters.dateTo;
    if (filters?.success !== undefined) params.success = filters.success;

    const response = await this.api.get<ApiResponse<LoginAuditPagedResponse>>('/loginaudits', { params });
    return this.extractData(response);
  }
}

export const loginAuditService = new LoginAuditService();
